import { PropsWithChildren } from 'react';

import { PropsWithCN, cn } from '@tg-web/utils';

type PageWrapperProps = PropsWithChildren & PropsWithCN;

export function PageWrapper({ children, className }: PageWrapperProps) {
  return (
    // overflow-auto, not overflow-scroll: `overflow: scroll` reserves and paints
    // scrollbar tracks unconditionally, so every page showed a permanent bar
    // whether or not it had anything to scroll. `auto` shows them only when the
    // content actually overflows.
    //
    // Almost every page passes `flex flex-col` in here, which makes this one
    // element both the scroll container and a definite-height flex column (body
    // is pinned to 100vh by AdditionalScrollFixer). That is fine for a child
    // whose overflow is `visible`, because its automatic minimum size keeps it
    // from shrinking below its content. A child that clips -- `overflow-hidden`
    // -- has no automatic minimum size, so it shrinks to fit instead, the
    // content never exceeds the column, and the page silently stops scrolling.
    // Such a child needs `shrink-0`; `Island` carries one for this reason.
    <div className={cn('h-full overflow-auto', className)}>{children}</div>
  );
}
